// extracted by mini-css-extract-plugin
export default {"wrapper":"ServicesHeader_wrapper__-12nL","title":"ServicesHeader_title__-Ne4w"};